import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=6bdbce64&scoped=true&"
import script from "./confirmModal.vue?vue&type=script&lang=js&"
export * from "./confirmModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=6bdbce64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdbce64",
  null
  
)

export default component.exports